import { render, staticRenderFns } from "./BalancePaid.vue?vue&type=template&id=8d49bb0a&"
import script from "./BalancePaid.vue?vue&type=script&lang=js&"
export * from "./BalancePaid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports